import { CaretRightOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Collapse, CollapseProps, Row } from "antd";
import cn from "classnames";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import React, { PropsWithChildren, ReactNode } from "react";

export type KeyValueFormProps = {
    title?: string;
    header?: string | ReactNode;
    extra?: ReactNode;
    addItemTitle?: string;
    handleAddItem?: () => void;
    withAddItem?: boolean;
    className?: string;
    wrapperClassName?: string;
} & PropsWithChildren &
    CollapseProps;

export const Collapseable: React.FC<KeyValueFormProps> = (props) => {
    const { t } = usePaldockTranslation("common");
    const {
        title,
        header,
        addItemTitle = t("add"),
        handleAddItem,
        children,
        withAddItem = false,
        className,
        extra,
        collapsible,
        defaultActiveKey,
        wrapperClassName,
    } = props;

    const panelHeader = header || title;

    const items = [
        {
            key: "1",
            label: (
                <div className="flex justify-between items-center w-full">
                    {panelHeader}
                    <div onClick={(e) => e.stopPropagation()}>{extra}</div>
                </div>
            ),
            children: (
                <Row gutter={16}>
                    <Col span={24}>
                        {children}
                        {withAddItem && (
                            <Button type="dashed" onClick={handleAddItem}>
                                <PlusOutlined /> {addItemTitle}
                            </Button>
                        )}
                    </Col>
                </Row>
            ),
        },
    ];

    return (
        <div className={cn("p-3", wrapperClassName)}>
            <Collapse
                className={cn(className, "w-full p-3")}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                collapsible={collapsible}
                defaultActiveKey={defaultActiveKey}
                ghost
                items={items}
            />
        </div>
    );
};
